import React, { Component } from 'react';

import Mailchimp from 'react-mailchimp-form'

const url = "https://vcmultichannel.us10.list-manage.com/subscribe/post?u=3ce7bea9055f80e8fedbc337a&amp;id=9fc1d1d8f7";


class MailSuscriptionContent extends Component {

    render() {
        return (
            <div className="content-mail-suscription">
                <h6>Suscríbete a nuestro boletín</h6>
                <Mailchimp
                    action={url}
                    fields={[
                    {
                        name: 'EMAIL',
                        placeholder: 'Email',
                        type: 'email',
                        required: true
                    }
                    ]}
                    messages = {
                        {
                          sending: "Enviando...",
                          success: "Gracias por suscribirte!",
                          error: "Ha ocurrido un error",
                          empty: "Debes ingresar un email.",
                          duplicate: "Demasiados intentos para este email",
                          button: "Suscríbete!"
                        }
                    }
                    className="form-mail-chimp"
                />
            </div>
        )
    }
}

export default MailSuscriptionContent


// WEBPACK FOOTER //
// ./src/Mailsuscription.js